import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "../../utils";

// export async function uploaxdFile(formData) {
//   try {
//     const { data: response } = await http("catalog-upload", {
//       method: "PUT",
//       data: formData,
//     });

//     return response;
//   } catch (error) {
//     console.log(error, "error");
//   }
// }

async function uploadFile(formData) {
  const data = await http(`/public/upload-s3/file`, {
    data: formData,
  });
  const publicUrl = data?.data?.data?.publicUrl;
  return await http("/admin/video/catalog", {
    data: {
      url: publicUrl,
    },
  });
}

export function useUploadFile() {
  const queryClient = useQueryClient();

  return useMutation(uploadFile, {
    onSuccess: () => {
      queryClient.refetchQueries(["catalog-upload"]);
    },
  });
}
